/* BEARE PARK – Related product scrollbars */

(function () {
  function initialiseScrollbars() {
    document.querySelectorAll('.section-related').forEach(function (section) {
      const grid = section.querySelector(
        '.similar-styles-grid, [data-related-products]'
      );

      const track = section.querySelector('[data-bp-scrollbar]');
      const thumb = section.querySelector('[data-bp-scrollbar-thumb]');

      if (!grid || !track || !thumb || track.dataset.initialised === 'true') {
        return;
      }

      track.dataset.initialised = 'true';

      function update() {
        const scrollable = grid.scrollWidth - grid.clientWidth;
        const trackWidth = track.clientWidth;

        const thumbWidth = scrollable > 0
          ? Math.max(20, trackWidth * grid.clientWidth / grid.scrollWidth)
          : trackWidth;

        thumb.style.width = thumbWidth + 'px';

        const maxThumbLeft = trackWidth - thumbWidth;

        thumb.style.left = (
          scrollable > 0
            ? (grid.scrollLeft / scrollable) * maxThumbLeft
            : 0
        ) + 'px';
      }

      track.addEventListener('pointerdown', function (event) {
        event.preventDefault();

        const rect = track.getBoundingClientRect();
        const thumbWidth = thumb.offsetWidth;
        const maxLeft = track.clientWidth - thumbWidth;
        const scrollable = grid.scrollWidth - grid.clientWidth;

        if (maxLeft <= 0 || scrollable <= 0) return;

        function move(e) {
          const left = Math.max(
            0,
            Math.min(maxLeft, e.clientX - rect.left - thumbWidth / 2)
          );

          grid.scrollLeft = (left / maxLeft) * scrollable;
          update();
        }

        move(event);

        track.setPointerCapture(event.pointerId);

        function stop() {
          track.removeEventListener('pointermove', move);
          track.removeEventListener('pointerup', stop);
          track.removeEventListener('pointercancel', stop);
        }

        track.addEventListener('pointermove', move);
        track.addEventListener('pointerup', stop);
        track.addEventListener('pointercancel', stop);
      });

     grid.addEventListener('scroll', update, { passive: true });
grid.addEventListener('theme:carousel:scroll', update);

/* Synchronise with Pipeline's existing scrollbar */
document.addEventListener('theme:scrollbar:scroll', function (event) {
  if (
    grid.matches('[data-related-products]') &&
    event.detail &&
    event.detail.holder === grid
  ) {
    update();
  }
});

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', initialiseScrollbars);
  document.addEventListener('shopify:section:load', initialiseScrollbars);
})();